import moment, { MomentInput } from "moment-timezone";

const dayOfWeekStringToMomentNumber = (dayOfWeek: string) => {
  switch (dayOfWeek) {
    case "sun":
      return 0;
    case "mon":
      return 1;
    case "tue":
      return 2;
    case "wed":
      return 3;
    case "thu":
      return 4;
    case "fri":
      return 5;
    case "sat":
      return 6;
    default:
      throw new Error("Invalid day of week");
  }
};

const getNextEventOnNthDayOfWeekInMonthMoment = ({
  currentEventStart,
  nth,
  dayOfWeek,
  skipMonths,
  timezone,
}: {
  currentEventStart: MomentInput;
  nth: number; // 1, 2, 3, 4 or -1 as last
  dayOfWeek: string; // "mon", "tue", "wed", etc.
  skipMonths: number;
  timezone: string;
}) => {
  const currentEventStartMoment = moment.tz(currentEventStart, timezone);
  const startOfTargetMonthMoment = currentEventStartMoment
    .clone()
    .startOf("month")
    .add(nth === -1 ? skipMonths + 1 : skipMonths, "month")
    .set("hour", currentEventStartMoment.hour())
    .set("minute", currentEventStartMoment.minute());

  const startOfMonthDayOfWeek = startOfTargetMonthMoment.day();
  const dayOfWeekNumber = dayOfWeekStringToMomentNumber(dayOfWeek);
  const firstXOfMonth = startOfTargetMonthMoment
    .clone()
    .add((dayOfWeekNumber - startOfMonthDayOfWeek + 7) % 7, "days");

  const weeksToAdd = nth === -1 ? -1 : nth - 1;

  return firstXOfMonth.clone().add(weeksToAdd, "weeks");
};

export default getNextEventOnNthDayOfWeekInMonthMoment;
